<template>
  <card>
    <apexchart
      type="bar"
      height="350"
      :options="genderChartOptions"
      :series="genderSeries"
    />
  </card>
</template>
<script>
export default {
  props: {
    headers: Array,
    series: Array
  },
  watch: {
    headers: {
      handler(data) {
        this.genderChartOptions = {
          tooltip: {
            y: {
              formatter: function(
                value
                // { series, seriesIndex, dataPointIndex, w }
              ) {
                return parseFloat(value).toLocaleString();
              }
            }
          },
          xaxis: {
            categories: data
          }
        };
      },
      deep: true
    },
    series: {
      handler(d_ata) {
        this.genderSeries = [
          {
            data: d_ata
          }
        ];
      },
      deep: true
    }
  },
  data() {
    return {
      genderChartOptions: {
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: this.headers
        }
      },
      genderSeries: [
        {
          data: [0, 0, 0]
        }
      ]
    };
  }
};
</script>
